<template>
    <form @prevent.submit>
        <div>
            <div class="a-table a-table--really-wide">
                <table class="a-table--full-width" cellpadding="0" cellspacing="0">
                    <thead>
                    <tr>
                        <th>From</th>
                        <th>To</th>
                        <th>Employment Type</th>
                        <th>Total Income per Annum</th>
                        <th>Income Type</th>
                        <th>Total Net Income per Annum</th>
                        <th></th>
                        <th></th>
                        <th>Delete Period</th>
                    </tr>
                    </thead>
                    <income-period v-for="(period, periodIndex) in periods"
                                   :start-disabled="startDisabled"
                                   :period="period"
                                   :index="periodIndex"
                                   :dependant="index"
                                   :maxIndex="periodsLength"
                                   :retired="retired"
                                   :lossOfEarnings="lossOfEarnings"
                                   :type="type"
                                   @update="updatePeriod"
                    ></income-period>
                </table>
            </div>

            <button class="a-button" type="button" role="button" @click="addIncomePeriod('future')">
                Add another period
            </button>
        </div>
    </form>
</template>

<script>
    import Vue from 'vue';
    import {validDate} from 'components/form/validator/validations';
    import {mapGetters, mapActions} from 'vuex';
    import IncomePeriod from './IncomePeriod';
    import Control from 'components/form/Control';
    import ControlError from 'components/form/control/Error';
    import DateInput from 'components/form/control/DateInput';
    import FormValidator from 'components/form/validator/mixin';

    export default {
        name: 'income',
        components: {
            Control,
            ControlError,
            DateInput,
            IncomePeriod,
        },
        props: {
            name: {
                type: String,
                required: true
            },
            income: {
                type: Object,
                required: true
            },
            index: {
                type: Number,
                default: null
            },
            retired: {
                type: Boolean,
                required: true
            },
            startDisabled: {
                type: Boolean,
                default: true,
            },
            lossOfEarnings: {
                type: Boolean,
                default: false
            },
            type: {
                type: String,
                default: "future"
            }
        },
        mixins: [
            FormValidator
        ],
        computed: {
            ...mapGetters('http', {
                loading: 'running'
            }),
            ...mapGetters('personal/claimant', ['claimant']),
            innerIncome() {
                let income = {};
                Vue.util.extend(income, this.income);
                return income;
            },
            periods() {
                return this.innerIncome[this.type+'Periods'];
            },
            periodsLength() {
                return this.periods.length;
            },
            incomeRules() {
                let periodIncomeCount = 0;

                this.periods.forEach(function (period, index) {
                    if (period['employmentIncome'] > 0 || period['pensionIncome'] > 0) {
                        periodIncomeCount++;
                    }
                }, this);

                return (periodIncomeCount > 0);
            },
        },
        methods: {
            ...mapActions('personal/claimant', [
                'addClaimantIncomePeriod',
                'addIncomePeriod',
                'updatePostInjuryIncomePeriod',
                'updateIncomePeriodForRetirementChange'
            ]),
            callAction() {
                this.$emit('action', {income: this.innerIncome, index: this.index});
            },
            updatePeriod(payload) {
                payload.type = this.type;
                this.updatePostInjuryIncomePeriod(payload)
            },
        }
    }
</script>


// WEBPACK FOOTER //
// FutureIncome.vue?a0a8d39e